import axios from 'axios';
import { datadogRum } from '@datadog/browser-rum';
import { CACHE_KEY_PREFIX, CACHE_KEY_USER_SUFFIX, COOKIES_KEY_PREFIX } from '../../constants';
import type { AuthObject } from '@white-label-types/auth';
import type { Context } from '@white-label-types/global-context';

export const fetchUserWrapper = async (
    token: string,
    app: Context['app'],
    authInstance: AuthObject
) => {
  try {
    const url = `https://${authInstance.domain}/userinfo`;
    const response = await axios.get(url, {
      headers: {
        Authorization: token,
      },
    });
    const userResponse = response.data;
    const userStorageKey = `${CACHE_KEY_PREFIX}::${authInstance.clientId}::${CACHE_KEY_USER_SUFFIX}`;
    const tokenNoBearer = token.replace('Bearer ', '');

    const userData = {
      decodedToken: {
        user: userResponse
      },
      id_token: tokenNoBearer,
    }

    // Persist user data to localStorage for session restoration across page reloads
    localStorage.setItem(userStorageKey, JSON.stringify(userData));

    // Set auth state directly from the API response.
    // We cannot rely solely on refreshUser() here because it queries the Auth0 SDK's
    // in-memory cache, which is only populated during createAuth0Client() or after
    // handleRedirectCallback(). Manually writing to localStorage does not update the
    // SDK's in-memory cache, so getUser()/isAuthenticated() would return undefined/false.
    authInstance.user = userResponse;
    authInstance.isAuthenticated = true;
  } catch (error) {
    const errorContext = {
      file: 'white-label-plugin > auth.ts > fetchUser()',
      domain: authInstance.domain || '',
      token: app['$cookies'].get(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.token`) || ''
    }
    datadogRum.addError(
      new Error('Auth fetchUser:', { cause: error }),
      errorContext
    );
  }
}
